import * as sizes from '../../sizes';
import { typography } from '../../typography/typography';
import type { ThemeDefinition } from '../types';

export const baseTheme: ThemeDefinition = {
  sizes,
  typography,
  colors: {},
};
